<template>
  <div>
    <section>
      <div id="storefront" class="storefront">
        <h1>Build Your Storefront</h1>
        <h2>
          Our storefront is more customizable than just a theme, you can
          customize much more
        </h2>
        <div class="theme-details">
          <div class="right-part">
            <img
              v-if="layout === 'gamer'"
              src="img/gamer.png"
              alt="Avatar"
              class="image"
            />
            <img
              v-if="layout === 'y2k'"
              src="img/y2k.png"
              alt="Avatar"
              class="image"
            />
            <img
              v-if="layout === 'tropical'"
              src="img/tropical.png"
              alt="Avatar"
              class="image"
            />
            <img
              v-if="layout === 'monochromatic'"
              src="img/monochromatic.png"
              alt="Avatar"
              class="image"
            />
          </div>

          <div class="left-part">
            <div class="gamer button" @click="layout = 'gamer'">
              <div class="black-bg">
                <p>Gamer</p>
              </div>
            </div>
            <div class="tropical button" @click="layout = 'tropical'">
              <div class="black-bg">
                <p>Tropical</p>
              </div>
            </div>
            <div class="y2k button" @click="layout = 'y2k'">
              <div class="black-bg">
                <p>Y2K</p>
              </div>
            </div>
            <div class="monochromatic button" @click="layout = 'monochromatic'">
              <div class="black-bg">
                <p>Monochromatic</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data: () => ({
    layout: 'monochromatic',
  }),
};
</script>

<style scoped>
.button {
  transition: 0.2s ease-in;
}

.button:hover {
  transform: translateY(-7px);
}

.gamer {
  background-image: url('/img/gamer-icon.svg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
}

.y2k {
  background-image: url('/img/y2k-icon.svg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
}

.tropical {
  background-image: url('/img/tropical-icon.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
}

.monochromatic {
  background-image: url('/img/panda-icon.svg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

section {
  width: 100%;
  padding: 2rem;
  text-align: center;
}

.storefront {
  max-width: 60rem;
  margin: auto;
  text-align: center;
  padding: 3rem 0;
}

.storefront h1 {
  font-size: 3.5rem;
  font-weight: 700;
  color: #ff5f8f;
  margin: 0;
}

.storefront h2 {
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  opacity: 0.5;
  color: black;
  margin-top: 0.7rem;
}

.theme-details {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  margin-top: 2rem;
}

.left-part {
  width: 60%;
  margin: auto;
  height: inherit;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.left-part div {
  display: flex;
  justify-content: center;
  align-content: center;
  height: inherit;
  width: 100%;
  border-radius: 5px;
  cursor: pointer;
  color: white;
  transition: 0.2s ease-in;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
}

.left-part div p {
  font-weight: 700;
  display: flex;
  padding: 1rem 0;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin: auto;
  transition: 0.2s ease-in;
  z-index: 999;
}

.right-part {
  width: 50rem;
  height: 20rem;
  margin: auto;
  margin-top: 3rem;
  margin-bottom: 3rem;
  position: relative;
  /* background-color: red; */
}

.right-part img {
  width: 50rem;
  top: 0;
  left: 0;
  position: absolute;
}

@media only screen and (max-width: 900px) {
  .right-part {
    width: 40rem;
    height: 20rem;
    margin-bottom: 1rem;
    /* background-color: blue; */
  }

  .right-part img {
    width: 40rem;
  }
}

@media only screen and (max-width: 800px) {
  .storefront h1 {
    font-size: 2.5rem;
  }

  .storefront h2 {
    text-align: center;
    font-size: 1rem;
  }

  .left-part {
    width: 100%;
  }

  .left-part div {
    width: 100%;
    margin: auto;
  }

  .left-part p {
    width: 100%;
  }

  .left-part label {
    margin: auto;
  }

  .left-part div p {
    padding: 1rem;
  }
}

@media only screen and (max-width: 700px) {
  .right-part {
    width: 30rem;
    height: 15rem;
    /* background-color: green; */
  }

  .right-part img {
    width: 30rem;
  }
}

@media only screen and (max-width: 600px) {
  .right-part {
    width: 100%;
    margin: 2rem auto;
    /* background-color: yellow; */
  }

  .right-part img {
    width: 100%;
  }
}

@media only screen and (max-width: 500px) {
  .right-part {
    height: 12.5rem;
    /* background-color: gray; */
  }
}

@media only screen and (max-width: 400px) {
  .right-part {
    height: 10rem;
    /* background-color: crimson; */
  }

  .left-part {
    grid-template-columns: 1fr;
  }
}
</style>
